// extracted by mini-css-extract-plugin
module.exports = {"text":"_1NKWcPO9Wzuibk6Z9LChS3"};